import React, { useState } from "react";

import FormInput from "components/atoms/input/FormInput";
import useLoading from "components/atoms/loading/useLoading";

import { ModalContainer, ModalDescText } from "components/organisms/modal/styled";
import AbstractModalFooter from "components/page/modal/AbstractModalFooter";

import { genericEnterKeyDown } from "utils/validation";

function ReferenceAddDoiModal(props) {
    const [doi, setDoi] = useState("");
    const { setLoading } = useLoading();

    const handleAddButton = () => {
        setLoading(true, "참고문헌 정보를 확인 중입니다.");
        props.mutation.mutate(
            {
                addFromSource: true,
                body: {
                    source: "doi",
                    source_id: doi,
                },
            },
            {
                onSettled: () => {
                    setLoading(false);
                },
            },
        );
    };

    return (
        <ModalContainer>
            <ModalDescText>참고문헌 추가를 위해 DOI를 입력해주세요.</ModalDescText>
            {/* DOI로 참고문헌 추가 기능 */}
            <FormInput
                width="100%"
                margin="24px 0 0 0"
                label="DOI"
                bgColor="var(--color-Base1)"
                borderless
                requiredMark
                rightInfoText="DOI"
                tooltipMessage="DOI(Digital Object Identifier)는 디지털 콘텐츠를 고유하게 식별하는 데 사용되는 표준 정보 식별자입니다."
                placeholder="EX) 10.1038/nature16961"
                onChange={(e) => setDoi(e.target.value)}
                onKeyDown={(e) => {
                    genericEnterKeyDown(e, () => {
                        handleAddButton();
                    });
                }}
                value={doi}
            />
            <AbstractModalFooter
                leftBtnText={"취소"}
                rightBtnText={"추가"}
                leftOnClick={props.exitModal}
                rightOnClick={handleAddButton}
                disabled={!doi}
            />
        </ModalContainer>
    );
}

export default ReferenceAddDoiModal;
